class CollectionSortComponent extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.debounceTimer = null;
    this.isProcessing = false;
  }

  connectedCallback() {
    if (!window.location.pathname.includes('/collections')) return;
    setTimeout(() => this.init(), 100);

    window.addEventListener('collectionUpdated', () => {
      this.destroy();
      this.init();
    });
    this.querySelector('.sort-btn').addEventListener('click', (e) => {
      this.sortModal(e.target);
    });
  }

  init() {
    this.initializeSortOrder();
    this.observeCollectionList();
    this.updateSortFromUrl();
  }

  initializeSortOrder() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');

    if (
      currentSort === 'alphabetical' ||
      currentSort === 'alphabetical_reversed' ||
      currentSort === 'date' ||
      currentSort === 'date_reversed' ||
      currentSort === 'count_high_to_low' ||
      currentSort === 'count_low_to_high'
    ) {
      if (
        currentSort === 'alphabetical' ||
        currentSort === 'alphabetical_reversed'
      ) {
        this.processTitleSort(currentSort);
      }
      if (currentSort === 'date' || currentSort === 'date_reversed') {
        this.processDateSort(currentSort);
      }
      if (
        currentSort === 'count_high_to_low' ||
        currentSort === 'count_low_to_high'
      ) {
        this.processProductsCountSort(currentSort);
      }

      const sort_by = this.querySelector(
        '#sort_by input[name="sort_by"]:checked',
      );
      if (sort_by) sort_by.value = currentSort;

      const radioInputs = this.querySelectorAll('input[name="sort_by"]');
      radioInputs.forEach((input) => {
        input.checked = input.value === currentSort;
      });
    }
  }

  observeCollectionList() {
    console.log('hello');
    const collectionList = this.querySelector('#collection-grid');
    if (!collectionList) return;

    this.observer = new MutationObserver((mutations) => {
      if (!this.isProcessing) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.handleDOMChanges(mutations);
        }, 100);
      }
    });

    this.observer.observe(collectionList, {childList: true});
    this.checkAndApplySort();
  }

  handleDOMChanges(mutations) {
    const hasNewCollections = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.classList.contains('collection-list__item') ||
            node.querySelector('.collection-list__item')),
      ),
    );

    if (hasNewCollections) {
      this.observer.disconnect();
      this.isProcessing = true;
      this.checkAndApplySort();
      const collectionList = this.querySelector('#collection-grid');
      if (collectionList) {
        this.observer.observe(collectionList, {childList: true});
      }
      this.isProcessing = false;
    }
  }

  checkAndApplySort() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (
      currentSort === 'alphabetical' ||
      currentSort === 'alphabetical_reversed' ||
      currentSort === 'date' ||
      currentSort === 'date_reversed' ||
      currentSort === 'count_high_to_low' ||
      currentSort === 'count_low_to_high'
    ) {
      if (
        currentSort === 'alphabetical' ||
        currentSort === 'alphabetical_reversed'
      ) {
        this.processTitleSort(currentSort);
      }
      if (currentSort === 'date' || currentSort === 'date_reversed') {
        this.processDateSort(currentSort);
      }
      if (
        currentSort === 'count_high_to_low' ||
        currentSort === 'count_low_to_high'
      ) {
        this.processProductsCountSort(currentSort);
      }
    }
  }

  destroy() {
    if (this.observer) this.observer.disconnect();
    clearTimeout(this.debounceTimer);
  }

  processTitleSort(sortDirection, updateUrl = true) {
    const collectionList = this.querySelector('#collection-grid');
    if (!collectionList) return;

    collectionList.classList.add('processing');

    const collections = Array.from(collectionList.children);

    const productsWithTitles = collections.map((product) => {
      const title = product.getAttribute('data-title')?.toLowerCase() || '';
      return {element: product, title};
    });

    // Sort using new keys
    productsWithTitles.sort((a, b) => {
      if (sortDirection === 'alphabetical') {
        return a.title.localeCompare(b.title);
      } else if (sortDirection === 'alphabetical_reversed') {
        return b.title.localeCompare(a.title);
      }
      return 0;
    });

    const fragment = document.createDocumentFragment();
    productsWithTitles.forEach((item) => fragment.appendChild(item.element));

    collectionList.innerHTML = '';
    collectionList.appendChild(fragment);
    collectionList.classList.remove('processing');

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortDirection);
      window.history.pushState({path: url.toString()}, '', url.toString());
    }
  }
  processDateSort(sortDirection, updateUrl = true) {
    const collectionList = this.querySelector('#collection-grid');
    if (!collectionList) return;

    collectionList.classList.add('processing');

    const collections = Array.from(
      collectionList.querySelectorAll('.collection-list__item'),
    );

    const productsWithDates = collections.map((product) => {
      const dateStr = product.getAttribute('data-date');
      const date = dateStr
        ? new Date(dateStr.replace(/ \+\d{4}$/, ''))
        : new Date(0); // Remove timezone for parsing
      return {element: product, date};
    });

    productsWithDates.sort((a, b) => {
      if (sortDirection === 'date') {
        return a.date - b.date; // Oldest to newest
      } else if (sortDirection === 'date_reversed') {
        return b.date - a.date; // Newest to oldest
      }
      return 0;
    });

    const fragment = document.createDocumentFragment();
    productsWithDates.forEach((item) => fragment.appendChild(item.element));

    collectionList.innerHTML = '';
    collectionList.appendChild(fragment);
    collectionList.classList.remove('processing');

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortDirection);
      window.history.pushState({path: url.toString()}, '', url.toString());
    }
  }
  processProductsCountSort(sortDirection, updateUrl = true) {
    const collectionList = this.querySelector('#collection-grid');
    if (!collectionList) return;

    collectionList.classList.add('processing');

    const collections = Array.from(
      collectionList.querySelectorAll('.collection-list__item'),
    );

    const productsWithCounts = collections.map((product) => {
      const countStr = product.getAttribute('data-product-count');
      const count = parseInt(countStr, 10) || 0;
      return {element: product, count};
    });

    productsWithCounts.sort((a, b) => {
      if (sortDirection === 'count_high_to_low') {
        return b.count - a.count;
      } else if (sortDirection === 'count_low_to_high') {
        return a.count - b.count;
      }
      return 0;
    });

    const fragment = document.createDocumentFragment();
    productsWithCounts.forEach((item) => fragment.appendChild(item.element));

    collectionList.innerHTML = '';
    collectionList.appendChild(fragment);
    collectionList.classList.remove('processing');

    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortDirection);
      window.history.pushState({path: url.toString()}, '', url.toString());
    }
  }

  sortModal(sortBtn) {
    this.sortModalElement = this.querySelector('.select-sorts');
    this.sortRadios = this.querySelectorAll('input[name="sort_by"]');

    // Toggle the modal visibility
    this.sortModalElement.classList.toggle('active');

    // Store reference to the component instance
    const self = this;

    // Remove existing event listeners to prevent duplicates
    this.sortRadios.forEach((radio) => {
      radio.removeEventListener('change', radio._changeHandler);
    });

    // Add new event listeners with proper context
    this.sortRadios.forEach((radio) => {
      radio._changeHandler = () => {
        if (self.sortModalElement.classList.contains('active')) {
          self.sortModalElement.classList.remove('active');
        }
        const url = new URL(window.location);
        url.searchParams.set('sort_by', radio.value);
        window.history.replaceState({}, '', url);

        const label = radio.closest('label');
        if (label) {
          const labelText = label.textContent.trim();
          this.querySelector('.sort-btn>.label').innerHTML = labelText;
        }

        const loadMoreBtn = this.querySelector('.infinite-loader');
        if (loadMoreBtn) {
          const rawNextUrl = loadMoreBtn.getAttribute('data-next-url');
          if (rawNextUrl) {
            const nextUrl = new URL(rawNextUrl, window.location.origin);
            nextUrl.searchParams.set('sort_by', radio.value);
            loadMoreBtn.setAttribute(
              'data-next-url',
              nextUrl.pathname + nextUrl.search,
            );
          }
        }

        this.checkAndApplySort();
      };
      radio.addEventListener('change', radio._changeHandler);
    });
  }
  updateSortFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const sortParam = params.get('sort_by');
    if (sortParam) {
      const radio = document.querySelector(
        `input[name="sort_by"][value="${sortParam}"]`,
      );
      const sortBtnText = this.querySelector('.sort-btn>.label');

      if (radio) {
        radio.checked = true;

        const label = radio.closest('label');
        if (label && sortBtnText) {
          const labelText = label.textContent.trim();
          sortBtnText.innerHTML = labelText;
        }
      }
    }
  }
}

customElements.define('main-collection-list', CollectionSortComponent);
